import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
  ElementRef,
  viewChild,
  AfterViewInit,
} from '@angular/core';

@Component({
  selector: 'app-note-editor',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="bg-white border border-slate-300 rounded p-2 shadow-lg w-64 text-sm text-slate-900">
      <div class="text-slate-600 mb-1">Note</div>
      <textarea
        #ta
        rows="3"
        class="w-full bg-white text-slate-900 border border-slate-300 rounded p-1"
        [value]="initial()"
        (keydown.escape)="cancelled.emit()"
      ></textarea>
      <div class="flex gap-2 mt-2">
        <button
          data-note-save
          class="px-2 py-1 border border-slate-300 rounded hover:bg-slate-100"
          (click)="onSave()"
        >
          Save
        </button>
        <button
          data-note-cancel
          class="px-2 py-1 border border-slate-300 rounded hover:bg-slate-100"
          (click)="cancelled.emit()"
        >
          Cancel
        </button>
      </div>
    </div>
  `,
})
export class NoteEditorComponent implements AfterViewInit {
  readonly initial = input<string>('');
  readonly saved = output<string>();
  readonly cancelled = output<void>();
  readonly taRef = viewChild<ElementRef<HTMLTextAreaElement>>('ta');

  ngAfterViewInit(): void {
    queueMicrotask(() => this.taRef()?.nativeElement.focus());
  }

  onSave(): void {
    this.saved.emit(this.taRef()?.nativeElement.value ?? '');
  }
}
